import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition } from './../../wayfinder'
import page from './page'
import projects46b84a from './projects'
import blog from './blog'
import user from './user'
import inquiry from './inquiry'
/**
* @see \App\Http\Controllers\Public\ProjectController::projects
* @see app/Http/Controllers/Public/ProjectController.php:24
* @route 'https://mktcode.digital/projetos'
*/
export const projects = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: projects.url(options),
    method: 'get',
})

projects.definition = {
    methods: ["get","head"],
    url: 'https://mktcode.digital/projetos',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Public\ProjectController::projects
* @see app/Http/Controllers/Public/ProjectController.php:24
* @route 'https://mktcode.digital/projetos'
*/
projects.url = (options?: RouteQueryOptions) => {
    return projects.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Public\ProjectController::projects
* @see app/Http/Controllers/Public/ProjectController.php:24
* @route 'https://mktcode.digital/projetos'
*/
projects.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: projects.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Public\ProjectController::projects
* @see app/Http/Controllers/Public/ProjectController.php:24
* @route 'https://mktcode.digital/projetos'
*/
projects.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: projects.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Public\ProjectController::projects
* @see app/Http/Controllers/Public/ProjectController.php:24
* @route 'https://mktcode.digital/projetos'
*/
const projectsForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: projects.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Public\ProjectController::projects
* @see app/Http/Controllers/Public/ProjectController.php:24
* @route 'https://mktcode.digital/projetos'
*/
projectsForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: projects.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Public\ProjectController::projects
* @see app/Http/Controllers/Public/ProjectController.php:24
* @route 'https://mktcode.digital/projetos'
*/
projectsForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: projects.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

projects.form = projectsForm

/**
* @see \App\Http\Controllers\Public\ServiceController::__invoke
* @see app/Http/Controllers/Public/ServiceController.php:15
* @route 'https://mktcode.digital/servicos'
*/
export const services = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: services.url(options),
    method: 'get',
})

services.definition = {
    methods: ["get","head"],
    url: 'https://mktcode.digital/servicos',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Public\ServiceController::__invoke
* @see app/Http/Controllers/Public/ServiceController.php:15
* @route 'https://mktcode.digital/servicos'
*/
services.url = (options?: RouteQueryOptions) => {
    return services.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Public\ServiceController::__invoke
* @see app/Http/Controllers/Public/ServiceController.php:15
* @route 'https://mktcode.digital/servicos'
*/
services.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: services.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Public\ServiceController::__invoke
* @see app/Http/Controllers/Public/ServiceController.php:15
* @route 'https://mktcode.digital/servicos'
*/
services.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: services.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Public\ServiceController::__invoke
* @see app/Http/Controllers/Public/ServiceController.php:15
* @route 'https://mktcode.digital/servicos'
*/
const servicesForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: services.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Public\ServiceController::__invoke
* @see app/Http/Controllers/Public/ServiceController.php:15
* @route 'https://mktcode.digital/servicos'
*/
servicesForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: services.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Public\ServiceController::__invoke
* @see app/Http/Controllers/Public/ServiceController.php:15
* @route 'https://mktcode.digital/servicos'
*/
servicesForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: services.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

services.form = servicesForm

/**
* @see \App\Http\Controllers\Public\AboutController::__invoke
* @see app/Http/Controllers/Public/AboutController.php:14
* @route 'https://mktcode.digital/sobre'
*/
export const about = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: about.url(options),
    method: 'get',
})

about.definition = {
    methods: ["get","head"],
    url: 'https://mktcode.digital/sobre',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Public\AboutController::__invoke
* @see app/Http/Controllers/Public/AboutController.php:14
* @route 'https://mktcode.digital/sobre'
*/
about.url = (options?: RouteQueryOptions) => {
    return about.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Public\AboutController::__invoke
* @see app/Http/Controllers/Public/AboutController.php:14
* @route 'https://mktcode.digital/sobre'
*/
about.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: about.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Public\AboutController::__invoke
* @see app/Http/Controllers/Public/AboutController.php:14
* @route 'https://mktcode.digital/sobre'
*/
about.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: about.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Public\AboutController::__invoke
* @see app/Http/Controllers/Public/AboutController.php:14
* @route 'https://mktcode.digital/sobre'
*/
const aboutForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: about.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Public\AboutController::__invoke
* @see app/Http/Controllers/Public/AboutController.php:14
* @route 'https://mktcode.digital/sobre'
*/
aboutForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: about.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Public\AboutController::__invoke
* @see app/Http/Controllers/Public/AboutController.php:14
* @route 'https://mktcode.digital/sobre'
*/
aboutForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: about.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

about.form = aboutForm

/**
* @see \App\Http\Controllers\Public\ContactController::__invoke
* @see app/Http/Controllers/Public/ContactController.php:14
* @route 'https://mktcode.digital/contato'
*/
export const contact = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: contact.url(options),
    method: 'get',
})

contact.definition = {
    methods: ["get","head"],
    url: 'https://mktcode.digital/contato',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Public\ContactController::__invoke
* @see app/Http/Controllers/Public/ContactController.php:14
* @route 'https://mktcode.digital/contato'
*/
contact.url = (options?: RouteQueryOptions) => {
    return contact.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Public\ContactController::__invoke
* @see app/Http/Controllers/Public/ContactController.php:14
* @route 'https://mktcode.digital/contato'
*/
contact.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: contact.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Public\ContactController::__invoke
* @see app/Http/Controllers/Public/ContactController.php:14
* @route 'https://mktcode.digital/contato'
*/
contact.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: contact.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Public\ContactController::__invoke
* @see app/Http/Controllers/Public/ContactController.php:14
* @route 'https://mktcode.digital/contato'
*/
const contactForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: contact.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Public\ContactController::__invoke
* @see app/Http/Controllers/Public/ContactController.php:14
* @route 'https://mktcode.digital/contato'
*/
contactForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: contact.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Public\ContactController::__invoke
* @see app/Http/Controllers/Public/ContactController.php:14
* @route 'https://mktcode.digital/contato'
*/
contactForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: contact.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

contact.form = contactForm

const publicMethod = {
    page: Object.assign(page, page),
    projects: Object.assign(projects, projects46b84a),
    services: Object.assign(services, services),
    about: Object.assign(about, about),
    contact: Object.assign(contact, contact),
    blog: Object.assign(blog, blog),
    user: Object.assign(user, user),
    inquiry: Object.assign(inquiry, inquiry),
}

export default publicMethod